export const Progress = {
    parts: [
        'label',
        'filledTrack',
        'track'
    ],
    variants: {
        default: {
            filledTrack: {
                bg: 'background.brand'
            },
            track: {
                bgColor: 'fill.light',
                h: '8px',
                borderRadius: '4px'
            }
        }
    },
    defaultProps: {
        variant: 'default'
    }
};

//# sourceMappingURL=progress.js.map